import { useEffect, useRef, useState } from "react";

/**
 * useCountUp – animates a number from 0 to `target` once `start` flips true.
 * Uses requestAnimationFrame with easeOutQuad for a natural decel curve.
 *
 *   const [ref, inView] = useInView();
 *   const value = useCountUp(500, inView, 1800);
 */
const useCountUp = (target, start, duration = 1500) => {
  const [value, setValue] = useState(0);
  const startedRef = useRef(false);

  useEffect(() => {
    if (!start || startedRef.current) return;
    startedRef.current = true;

    const startTime = performance.now();
    let raf;

    const tick = (now) => {
      const elapsed = now - startTime;
      const t = Math.min(elapsed / duration, 1);
      // easeOutQuad – snappy then decelerates
      const eased = 1 - (1 - t) * (1 - t);
      setValue(Math.round(eased * target));
      if (t < 1) raf = requestAnimationFrame(tick);
    };

    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [start, target, duration]);

  return value;
};

export default useCountUp;
